import { api } from "./axios";

export interface GeositeCategory {
  name: string;
  display_name?: string;
  domain_count: number;
  default_routing: string;
  user_routing?: string;
  effective: string;
}

export interface AdminGeositeCategory {
  name: string;
  source: "dlc" | "custom";
  domain_count: number;
  default_routing: string;
}

export interface GeositeTreeNode {
  name: string;
  domain_count: number;
  default_routing: string;
  children: string[];
}

export interface CategoryDetail {
  name: string;
  source: "dlc" | "custom";
  display_name?: string;
  domains: Array<{
    domain: string;
    rule_type: string;
  }>;
}

export interface UserTreeNode {
  name: string;
  domain_count: number;
  default_routing: string;
  user_routing?: string;
  children: string[];
}

export interface PreviewResult {
  domain: string;
  ip: string;
  decision: string;
  reason: string;
  matched_categories: Array<{
    name: string;
    routing: string;
    source: string;
  }>;
}

export interface CustomCategory {
  id: number;
  name: string;
  display_name?: string;
  domain_count?: number;
  default_routing?: string;
}

export const fetchGeositeCategories = () => api.get<{ categories: GeositeCategory[] }>("/api/geosite/categories");

export const fetchUserGeositeTree = () => api.get<{ categories: UserTreeNode[] }>("/api/geosite/tree");

export const setGeositeRouting = (name: string, routing: string) =>
  api.post(`/api/geosite/categories/${encodeURIComponent(name)}/route`, new URLSearchParams({ routing_type: routing }), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

export const previewRouting = (domain: string) =>
  api.post<{ domain: string; ip: string; decision: string; reason: string; matched_categories: PreviewResult["matched_categories"] }>("/api/geosite/preview", new URLSearchParams({ domain }));

// Admin APIs
export const fetchGeositeTree = () => api.get<{ categories: GeositeTreeNode[] }>("/api/admin/geosite/tree");

export const fetchAdminCategories = () => api.get<{ categories: AdminGeositeCategory[] }>("/api/admin/geosite/categories");

export const setCategoryDefault = (name: string, defaultRouting: string) =>
  api.post(`/api/admin/geosite/categories/${encodeURIComponent(name)}/default`, new URLSearchParams({ default_routing: defaultRouting }), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

export const fetchCategoryDetail = (name: string) =>
  api.get<CategoryDetail>(`/api/admin/geosite/categories/${encodeURIComponent(name)}`);

export const fetchCustomCategories = () => api.get<{ categories: CustomCategory[] }>("/api/admin/geosite/custom");

export const createCustomCategory = (data: { name: string; display_name?: string }) =>
  api.post("/api/admin/geosite/custom", new URLSearchParams(data), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

export const deleteCustomCategory = (id: number) => api.delete(`/api/admin/geosite/custom/${id}`);

export const reloadGeosite = () => api.post("/api/admin/geosite/reload");
